import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { Homepage } from './homepage'
import { Plans } from './plans'
import { GetUsage } from './get_usage'
import { Enrollment } from './enrollment'
import Footer from './components/footer'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { ThemeProvider } from 'styled-components'
import 'react-datetime/css/react-datetime.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import qs from 'qs'
import {
    faFilePdf,
    faTimesCircle,
    faSearch,
    faCheckCircle,
    faCheckSquare,
    faCircle,
    faSquare,
    faBars,
    faArrowDown,
    faTimes,
    faSlidersH,
    faCaretUp,
    faCaretDown,
    faExchangeAlt,
    faInfoCircle,
    faArrowLeft,
} from '@fortawesome/free-solid-svg-icons'
import './i18n'
import { ShoppingTips } from './pages/shopping-tips'
import { SavingCalculation } from './pages/saving-calculation'
import { LetterOfAuthorization } from './pages/letter-of-authorization'
import { Faq } from './pages/faq'
import { About } from './pages/about'
import { Contact } from './pages/contact'
import { GoogleAnalytics } from './components/GoogleAnalytics'
import { ScrollToTop } from './components/ScrollToTop'
import { ErrorBoundary } from './components/ErrorBoundary'
import { theme } from './theme'

library.add(
    faFilePdf,
    faTimesCircle,
    faSearch,
    faCheckCircle,
    faCheckSquare,
    faCircle,
    faSquare,
    faBars,
    faArrowDown,
    faTimes,
    faSlidersH,
    faCaretUp,
    faCaretDown,
    faExchangeAlt,
    faInfoCircle,
    faArrowLeft
)

const RESERVED_PATHS = [
    'plans',
    'get_usage',
    'enrollment',
    'about',
    'contact',
    'faq',
    'shopping_tips',
    'saving_calculation',
    'letter_of_authorization',
]

const getPromoCodeFromLocation = (pathname: string, search: string) => {
    const { promo_code: queryPromo } = qs.parse(search, { ignoreQueryPrefix: true })
    if (typeof queryPromo === 'string' && queryPromo) {
        return queryPromo
    }

    const segments = pathname.split('/').filter(Boolean)
    if (segments.length === 1 && !RESERVED_PATHS.includes(segments[0])) {
        return segments[0]
    }

    return undefined
}

/** Persist promo from URL into cookie. Must live under BrowserRouter. */
function PromoCodeCookie() {
    const { pathname, search } = useLocation()
    const [cookies, setCookie] = useCookies(['promo_code'])
    const promoCode = getPromoCodeFromLocation(pathname, search)

    useEffect(() => {
        if (promoCode && cookies.promo_code !== promoCode) {
            setCookie('promo_code', promoCode, { path: '/', maxAge: 1209600 })
        }
    }, [promoCode, cookies.promo_code, setCookie])

    return null
}

function App() {
    return (
        <ErrorBoundary>
            <a className="sr-only" href="#main-content">
                Skip to main content
            </a>
            <ThemeProvider theme={theme}>
            <BrowserRouter>
                <ScrollToTop />
                <GoogleAnalytics />
                <PromoCodeCookie />
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/get_usage" element={<GetUsage />} />
                    <Route path="/enrollment" element={<Enrollment />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/shopping_tips" element={<ShoppingTips />} />
                    <Route path="/saving_calculation" element={<SavingCalculation />} />
                    <Route path="/letter_of_authorization" element={<LetterOfAuthorization />} />
                    <Route path="/:promoCode" element={<Homepage />} />
                </Routes>
            </BrowserRouter>
            <Footer />
            <ToastContainer />
        </ThemeProvider>
        </ErrorBoundary>
    )
}

export default App
